import React from 'react';
import residentialImg from '../../assets/img/BestArchitecture/Residential.png';
import commercialImg from '../../assets/img/BestArchitecture/Commercial.png';
import urbanImg from '../../assets/img/BestArchitecture/Urban.png';
import industrialImg from '../../assets/img/BestArchitecture/Industrial Sector.png';
import interiorImg from '../../assets/img/BestArchitecture/Interior Design.png';
import institutionalImg from '../../assets/img/BestArchitecture/Institutional Projects.png';
import { ArrowRight } from 'lucide-react';

const BestArchitectureSection = ({ title, subtitle, industries: customIndustries }) => {
  const defaultIndustries = [
    {
      title: "Residential",
      desc: "Designing and building homes, apartments, and other living spaces.",
      backContent: "Efficient Scan-to-BIM modeling for villas and multi-family residential complexes. Detailed floor plans and 3D architectural renders tailoring to modern home designs.",
      img: residentialImg
    },
    {
      title: "Commercial",
      desc: "This sector focuses on developing properties for business purposes, including office buildings, retail centers malls, restaurants & hotels.",
      backContent: "Our commercial BIM services streamline the planning of high-rise offices, hotels, and retail malls, providing precise CAD and Revit models for large-scale development.",
      img: commercialImg
    },
    {
      title: "Institutional Projects",
      desc: "We design essential public spaces to serve communities, including schools, universities, hospitals, & government buildings.",
      backContent: "Specialized landscape integration within BIM environments, including topography, outdoor features, and horticultural planning for sustainable environments.",
      img: institutionalImg
    },
    {
      title: "Industrial Sector",
      desc: "We plan and design industrial facilities. This includes factories, warehouses, & manufacturing plants built for efficiency & future growth.",
      backContent: "Heavy-duty BIM modeling for warehouses, manufacturing plants, and logistics hubs. Precise coordination of MEPF and structural industrial components.",
      img: industrialImg
    },
    {
      title: "Urban",
      desc: "We shape cities by blending green spaces with functional design. Our goal is to create sustainable, livable communities for everyone.",
      backContent: "Urban planning solutions including master planning, city modeling, and infrastructure visualization for large city developments and smart city projects.",
      img: urbanImg
    },
    {
      title: "Interior Design",
      desc: "Focusing on the internal spaces of buildings, including layout, furniture, and finishes.",
      backContent: "High-precision interior BIM detailing. Visualizing fit-outs, space optimization, and architectural finishes to provide a complete internal spatial experience.",
      img: interiorImg
    }
  ];

  const displayIndustries = customIndustries || defaultIndustries;

  return (
    <section className="best-architecture-section">
      <div className="best-architecture-container">
        <div className="best-architecture-header">
          <h2 className="best-architecture-title">
            {title || (
              <>
                <span style={{ color: '#54b248' }}>Best Architecture Scan to</span> <span style={{ color: 'white' }}>BIM Services Company</span> Across industries.
              </>
            )}
          </h2>
          <p className="best-architecture-subtitle">
            {subtitle || "Scan to BIM has gained experience in a wide range of industries, enabling us to provide top-notch architectural outsourcing solutions with valuable insights."}
          </p>
        </div>

        <div className="best-architecture-grid">
          {displayIndustries.map((item, index) => (
            <div key={index} className="best-architecture-flip-card">
              <div className="best-architecture-card-inner">
                {/* -- FRONT SIDE -- */}
                <div className="best-architecture-card-front">
                  <div className="best-architecture-icon">
                    <img src={item.img.src || item.img} alt={item.title} className="card-custom-img" />
                  </div>
                  <h4 className="best-architecture-card-title">{item.title}</h4>
                  <p className="best-architecture-card-desc">{item.desc}</p>
                </div>

                {/* -- BACK SIDE (Learn More on Click feature) -- */}
                <div className="best-architecture-card-back">
                   <h4 className="back-title">Key Insights</h4>
                   <p className="extra-content">{item.backContent}</p>
                   <button className="learn-more-btn">
                     Learn More <ArrowRight size={16} style={{ marginLeft: '6px' }} />
                   </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestArchitectureSection;
